import { useNavigate } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showSubtitle?: boolean;
  subtitle?: string;
  textColor?: string;
  iconBg?: string;
  iconColor?: string;
  onClick?: () => void;
  className?: string;
}

export default function Logo({
  size = 'md',
  showSubtitle = false,
  subtitle = 'JIN AN CHINA',
  textColor = 'text-brown-900',
  onClick,
  className = '',
}: LogoProps) {
  const navigate = useNavigate();

  const imgSize = size === 'sm' ? 'h-10' : size === 'lg' ? 'h-16' : 'h-14';
  const textSize = size === 'sm' ? 'text-base' : size === 'lg' ? 'text-2xl' : 'text-lg';
  const subtitleSize = size === 'sm' ? 'text-[10px]' : size === 'lg' ? 'text-xs' : 'text-xs';

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/home');
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex ${size === 'lg' ? 'flex-col items-center' : 'items-center'} ${size === 'sm' ? 'gap-2' : 'gap-3'} cursor-pointer ${className}`}
    >
      <img
        src="https://storage.helloreaddy.io/project_files/32dff06f-e06f-43d6-b35d-aa49da94ab42/37d208d7-78d4-44b4-aedf-b83ada0bdf0f_compressed_jin_an_china_JAC_icon_transparent_1024.webp"
        alt="金安中国"
        className={`${imgSize} w-auto object-contain flex-shrink-0`}
      />
      <div className={`flex flex-col ${size === 'lg' ? 'items-center' : 'items-center'} ${size === 'lg' ? '' : 'mt-1.5'}`}>
        <span className={`${textSize} font-bold ${textColor} leading-tight tracking-tight whitespace-nowrap`}>
          金安中国
        </span>
        {showSubtitle && (
          <span className={`${subtitleSize} text-gold-500 leading-tight tracking-wider`}>
            {subtitle}
          </span>
        )}
      </div>
    </button>
  );
}